// extracted by mini-css-extract-plugin
module.exports = {"userPhoto":"Users_userPhoto__1eDhb","selectedPage":"Users_selectedPage__2POqJ"};